import { i18n } from '@lingui/core';

export interface EditBinderCostRecordPageParams extends Record<string, string | undefined> {
  projectId: string
  binderCostRecord: string;
}
export const ROUTE_PARAM_IDENTIFIER = ':projectId';
export const BINDER_COST_RECORD_PARAM_IDENTIFIER = ':binderCostRecord';
export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/binder-cost-records/${BINDER_COST_RECORD_PARAM_IDENTIFIER}`;
export const TITLE = i18n._('Edit Binder Cost Record');
